import {
  useCallback,
  useEffect,
  useRef,
} from 'react';

import { FormTextarea } from '@/core/components/FormTextarea';

interface AutoResizingTextareaProps {
  hiddenLabel: string;
  backgroundcolor: string;
  isDisabled: boolean;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus: () => void;
  value: string;
}

export const AutoResizingTextarea = ({
  hiddenLabel,
  backgroundcolor,
  isDisabled,
  onChange,
  onFocus,
  value,
}: AutoResizingTextareaProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const adjustHeight = useCallback(() => {
    if (wrapperRef.current) {
      const textarea = wrapperRef.current.querySelector('textarea');

      if (textarea) {
        const maxHeight = window.innerHeight * 0.8;

        textarea.style.height = 'auto';
        const newHeight = Math.min(textarea.scrollHeight, maxHeight);

        textarea.style.height = `${newHeight}px`;
      }
    }
  }, []);

  useEffect(() => {
    adjustHeight();
  }, [
    value,
    adjustHeight,
  ]);

  return (
    <div ref={wrapperRef}>
      <FormTextarea
        hiddenLabel={hiddenLabel}
        backgroundcolor={backgroundcolor}
        isDisabled={isDisabled}
        onChange={onChange}
        onFocus={onFocus}
        value={value}
      />
    </div>
  );
};
